<template>
  <div class="accordion" :id="accordionOuterId">
    <div class="accordion-item accordion-layout" :class="{ disabled: disabled }">
      <a
        href="#"
        class="d-flex justify-content-between align-items-center accordion-layout-inner"
        data-bs-toggle="collapse"
        :data-bs-target="'#' + accordionInnerId"
        @click="toggle"
      >
        <div class="form-check d-flex align-items-center">
          <label class="form-check-label NKT-P1"
            >Alarms {{ alarmCount ? ' (' + alarmCount + ')' : '(0)' }}</label
          >
        </div>
        <div>
          <MsButton
            :disabled="disabled"
            data-bs-toggle="collapse"
            :data-bs-target="'#' + accordionInnerId"
            aria-expanded="false"
            :aria-controls="accordionInnerId"
          >
            <img
              :src="disabled ? lock : arrow"
              class="icon"
              :class="{ rotated: isExpanded && !disabled }"
            />
          </MsButton>
        </div>
      </a>

      <div
        :id="accordionInnerId"
        class="accordion-collapse collapse"
        :data-bs-parent="'#' + accordionOuterId"
      >
        <ul v-if="alarmCount" class="list-group scrollable-list-group">
          <a
            @click="alarmClick(alarm)"
            href="#"
            class="list-group-item list-group-item-action"
            v-for="(alarm, index) in alarms"
            :key="index"
            aria-current="true"
          >
            <div class="d-flex justify-content-between">
              <div class="flex-grow-1">
                <AlarmSources :alarmSources="alarm.alarmSources"></AlarmSources>
              </div>
              <div class="NKT-P1">
                <DateTime :timestamp="alarm.timestamp"></DateTime>
              </div>
            </div>

            <div class="d-flex justify-content-between mt-2">
              <KpCell :kp="alarm.kp" color="black"></KpCell>
              <CoordinateCell
                color="black"
                :coordinates="[alarm.coordinate?.latitude ?? 0, alarm.coordinate?.longitude ?? 0]"
              ></CoordinateCell>
            </div>

            <div class="mt-2"><AlarmDescriptionCell :alarm="alarm"></AlarmDescriptionCell></div>
          </a>
          <li v-if="alarmCount > 20" class="list-group-item list-group-item-action NKT-P1">
            There are more alarms. Please visit the Alarm log page.
          </li>
        </ul>
        <div v-else class="list-group scrollable-list-group">
          <span class="list-group-item list-group-item-action NKT-P1">
            No alarms detected at selected time.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AlarmSources from '@/components/cells/AlarmSourcesCell.vue'
import DateTime from '@/components/cells/DateTimeCell.vue'
import KpCell from '@/components/cells/KpCell.vue'
import AlarmDescriptionCell from '@/components/cells/AlarmDescriptionCell.vue'
import CoordinateCell from '@/components/cells/CoordinateCell.vue'
import { Alarm } from '@/server/MakeSenseApp-backend'
import { ref, defineProps, defineEmits } from 'vue'
import MsButton from '@/components/general/buttons/MsButton.vue'
import arrow from '@/assets/svg/arrow.svg'
import lock from '@/assets/svg/lock-gray.svg'

const props = defineProps({
  alarms: Array<Alarm>,
  alarmCount: Number,
  disabled: {
    type: Boolean,
    default: false
  }
})

const accordionInnerId = ref('accordion-filter-alarms')
const accordionOuterId = ref('dropdown-filter-alarms')

const emit = defineEmits(['alarm-click'])

function alarmClick(alarm: Alarm) {
  if (alarm && alarm.id) {
    alarm.visited = true
    emit('alarm-click', alarm.id)
  }
}

const isExpanded = ref(false)

const toggle = () => {
  if (!props.disabled) {
    isExpanded.value = !isExpanded.value
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.accordion-layout {
  width: 400px;

  border-radius: var(--border-radius-small-tryout, 4px);
  background: color.$color-white;

  /* Dropeffect */
  box-shadow: 0px 0px 0.5px 0px rgba(66, 71, 76, 0.32), 0px 4px 8px 0px rgba(66, 71, 76, 0.05);
}

.accordion-layout-inner {
  height: 40px;
  border-bottom: 1px solid var(--color-neutrals-light-grey, #e7e7e6);
}

.scrollable-list-group {
  max-height: 400px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: auto;
  ::-webkit-scrollbar {
    display: none;
  }
}

.cell-color {
  color: black !important;
}

.disabled {
  pointer-events: none;
}
</style>
